import React from "react";

export default function ItemsPerPage(props){
    const itemsArray=props.config.itemsPerPageArray || [5,10,25,50];
    return (
        <div className="finderTable-items-per-page">
            <label>{window.finderTable.dict.itemsPerPage}</label>
            <select value={props.elBinding} onChange={props.onChange}>
                {itemsArray.map((item,index)=><option key={item} value={item}>{item}</option>)}
            </select>
        </div>
    );
}